import { createFlagsScheme, schema } from '@funtech-int/yango-shared';

export const featureFlagsScheme = createFlagsScheme({
    isNewPlayerEnabled: schema.boolean.optional(false),
});
